if(showcc){

	// ===== PATCH: Visibility-Schutzschicht (LCP-Protection) ======================
	// Hintergrund: orestbida/cookieconsent v3 erzeugt bei disablePageInteraction:true
	// einen Overlay-Layer (.cc__overlay), der den GESAMTEN Viewport abdeckt. Das ist
	// das grösste sichtbare Element auf der Seite -> Lighthouse misst es als LCP.
	// Selbst das Banner (#cm) im "box wide"-Layout ist auf Mobile gross genug, um
	// als LCP-Element gemessen zu werden, sobald es sichtbar ist.
	//
	// Strategie: Wurzel-Container (#cc-main), Banner (#cm), Modal (#pm) und Overlay
	// (.cc__overlay) per CSS unsichtbar halten, bis body.cc-ready gesetzt ist.
	// Lighthouse misst LCP dann am Hero-Bild, nicht am Banner/Overlay.
	//
	// Selektor-Quelle: https://cookieconsent.orestbida.com/advanced/ui-customization.html
	// (DOM-IDs #cc-main, #cm, #pm sind plugin-konstant, layout-unabhängig).
	(function injectCcVisibilityCSS(){
		if(document.getElementById('cc-visibility-protect')) return;
		var s = document.createElement('style');
		s.id = 'cc-visibility-protect';
		s.textContent =
			'#cc-main,' +
			'#cc-main .cm,' +
			'#cc-main .pm,' +
			'.cc__overlay {' +
				'opacity: 0 !important;' +
				'visibility: hidden !important;' +
				'transition: opacity .3s ease, visibility .3s ease;' +
			'}' +
			'body.cc-ready #cc-main,' +
			'body.cc-ready #cc-main .cm,' +
			'body.cc-ready #cc-main .pm,' +
			'body.cc-ready .cc__overlay {' +
				'opacity: 1 !important;' +
				'visibility: visible !important;' +
			'}';
		(document.head || document.documentElement).appendChild(s);
	})();
	// ===== /PATCH: Visibility-Schutzschicht ende =================================


	// ===== PATCH FIX 2026-05-03: iframemanager aus CookieConsent-Init herauslösen
	// Bug: Bei vorhandenem cc_cookie wurde __initCookieConsent() im Skip-Path
	// komplett übersprungen (siehe __deferCC unten). Damit lief auch im.run() nie,
	// das im Original-Code innerhalb __initCookieConsent() initialisiert wurde.
	// Folge: <div data-service="youtube"> Container blieben leer - kein Thumbnail,
	// keine Consent-Notice. Wiederkehrende Besucher mit reject-Status sahen
	// einfach eine weisse Fläche statt des YouTube-Vorschaubilds.
	//
	// Fix: iframemanager wird in eigener Funktion __initIframeManager() initialisiert
	// und IMMER ausgeführt, wenn YT/X auf der Seite ist - auch im Skip-Path. Der
	// gespeicherte Consent-Stand wird via __syncIframeManagerWithStoredConsent()
	// in den iframemanager übernommen, damit Accept-Stati persistent bleiben.
	//
	// Plugin-Doku: iframemanager scannt das DOM erst beim im.run()-Aufruf nach
	// [data-service] Elementen. Ohne im.run() = leerer Container.
	// Ref: https://github.com/orestbida/iframemanager
	// ===========================================================================

	var __ccInited = false;
	var __imInited = false;
	var __im = null;

	// iframemanager IMMER initialisieren, wenn YouTube/X-Embeds auf der Seite sind -
	// unabhängig vom CookieConsent-Status. Idempotent (mehrfache Aufrufe sind safe).
	function __initIframeManager(){
		if(__imInited) return;
		var hasYoutube = $('[data-service="youtube"]').length;
		var hasTwitter = $('[data-service="twitter"]').length;
		if(!hasYoutube && !hasTwitter) return;
		__imInited = true;

		__im = iframemanager();
		__im.run({

			onChange: ({ eventSource, changedServices }) => {
				console.log(changedServices)

				if(eventSource.type === 'click'){
					// Sync nur wenn CookieConsent bereits initialisiert ist.
					// Im Skip-Path (cc_cookie schon vorhanden) ist CC nicht geladen -
					// der iframemanager persistiert seinen State über eigene Cookies
					// (im_youtube, im_twitter), das ist OK und entkoppelt designed.
					if(window.CookieConsent && typeof CookieConsent.getUserPreferences === 'function'){
						try {
							var prefs = CookieConsent.getUserPreferences();
							if(prefs && prefs.acceptedServices && prefs.acceptedServices.media){
								CookieConsent.acceptService(
									[
										...prefs.acceptedServices.media,
										...changedServices
									],
									'media'
								);
							}
						} catch(err){
							// CookieConsent noch nicht ready - kein Sync möglich
						}
					}
				}
			},

			currLang: langdouble,

			services : {
				youtube : {
					embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
					thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',

					iframe : {
						allow : 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;',
					},

					languages : {
						de : {
							notice: trans['d'].trans_cc_youtube_frage,
							loadBtn: trans['d'].trans_cc_youtube_watch,
							loadAllBtn: trans['d'].trans_cc_youtube_ja
						},
						en : {
							notice: trans['e'].trans_cc_youtube_frage,
							loadBtn: trans['e'].trans_cc_youtube_watch,
							loadAllBtn: trans['e'].trans_cc_youtube_ja
						}
					}
				},
				twitter: {
					onAccept: async (div, setIframe) => {
						await CookieConsent.loadScript('https://platform.twitter.com/widgets.js');
						await __im.childExists({childProperty: 'twttr'}) && await twttr.widgets.load(div);
						await __im.childExists({parent: div}) && setIframe(div.querySelector('iframe'));
						$('.stweet').hide();
					},

					onReject: (iframe) => {
						$('.stweet').show();
						iframe && iframe.parentElement.remove();
					}
				}
			}
		});

		// Stored Consent in iframemanager-State übernehmen.
		// Wichtig für: User akzeptiert beim 1. Besuch -> Reload -> Iframe soll direkt
		// laden, nicht erst die Notice zeigen.
		__syncIframeManagerWithStoredConsent();

		// .off()/.on() = Re-Bind-Schutz (idempotent), falls die Funktion doch
		// versehentlich mehrfach läuft (z.B. nach Plugin-Update).
		$('.stweet .btn').off('click.ccpatch').on('click.ccpatch', function(e){
			$('.stweet').hide();
			__im.acceptService('twitter');
			if(window.CookieConsent && typeof CookieConsent.getUserPreferences === 'function'){
				try {
					var prefs = CookieConsent.getUserPreferences();
					if(prefs && prefs.acceptedServices && prefs.acceptedServices.media){
						CookieConsent.acceptService(
							[
								...prefs.acceptedServices.media,
								...['twitter']
							],
							'media'
						);
					}
				} catch(err){
					// CC nicht bereit - iframemanager-Cookie übernimmt
				}
			}
		});
	}

	// Liest cc_cookie und ZWINGT den iframemanager-State in Sync mit cc_cookie.
	// BIDIREKTIONAL: wenn Service accepted -> acceptService, wenn nicht -> rejectService.
	// Suche kategorienübergreifend (services.analytics + services.media + ...), weil
	// derselbe Service in mehreren Kategorien sein kann (OR-Logik).
	//
	// WARUM ZWINGEN STATT NUR ACCEPT: Der iframemanager hat seinen eigenen Cookie
	// (im_youtube, im_twitter), den er beim im.run() liest und auf dessen Basis
	// das iframe automatisch lädt - unabhängig vom cc_cookie. Ohne expliziten
	// rejectService würde ein veralteter im_youtube-Cookie ein Video laden, obwohl
	// cc_cookie sagt "media disabled". Der User toggelt media off, onReject feuert
	// nicht (CookieConsent denkt "war nie accepted in dieser Session"), iframe bleibt.
	// Bug-Fix 2026-05-03 (Iteration 2).
	function __syncIframeManagerWithStoredConsent(){
		if(!__im) return;
		try {
			var ccCookieRaw = document.cookie.split('; ').find(function(r){
				return r.indexOf('cc_cookie=') === 0;
			});
			if(!ccCookieRaw){
				// Kein cc_cookie -> trotzdem rejecten falls stale im_*-Cookies da sind
				__forceRejectAllIframeServices();
				return;
			}
			var json = decodeURIComponent(ccCookieRaw.substring('cc_cookie='.length));
			var obj = JSON.parse(json);

			// Service kategorienübergreifend suchen (kann in mehreren Kategorien sein)
			var isAccepted = function(serviceName){
				if(!obj.services) return false;
				for(var cat in obj.services){
					var arr = obj.services[cat];
					if(Array.isArray(arr) && arr.indexOf(serviceName) > -1) return true;
				}
				return false;
			};

			// YouTube: BEIDSEITIG syncen (accept ODER reject, nicht nur einseitig!)
			if($('[data-service="youtube"]').length > 0){
				if(isAccepted('youtube')) __im.acceptService('youtube');
				else __im.rejectService('youtube');
			}
			// Twitter: dito
			if($('[data-service="twitter"]').length > 0){
				if(isAccepted('twitter')) __im.acceptService('twitter');
				else __im.rejectService('twitter');
			}
		} catch(e){
			// Cookie nicht parsebar -> sicherste Variante: alles rejecten
			__forceRejectAllIframeServices();
		}
	}

	function __forceRejectAllIframeServices(){
		if(!__im) return;
		try {
			if($('[data-service="youtube"]').length > 0) __im.rejectService('youtube');
			if($('[data-service="twitter"]').length > 0) __im.rejectService('twitter');
		} catch(e){}
	}
	// ===== /PATCH FIX ende =====================================================


	// ===== PATCH: Init in Funktion kapseln, idempotent ============================
	function __initCookieConsent(){
		if(__ccInited) return;
		__ccInited = true;

		// iframemanager hier zur Sicherheit nochmal triggern (idempotent durch Flag)
		__initIframeManager();

		CookieConsent.run({
			disablePageInteraction:false,
			cookie: {
				expiresAfterDays: 182
			},
			revision: rev,
			autoClearCookies:true,
			hideFromBots: true,
			//manageScriptTags: true,
			guiOptions: {
				consentModal: {
					layout: "bar",
					position: "bottom center",
					equalWeightButtons: true,
					flipButtons: true
				},
				preferencesModal: {
					layout: "bar wide",
					position: "left",
					equalWeightButtons: true,
					flipButtons: true
				}
			},

			onFirstConsent: ({cookie}) => {
				//console.log('onFirstConsent fired',cookie);
			},

			onConsent: ({cookie}) => {
				$.post('/assets/inc/setGDPR.cfm?_cache=' + new Date().getTime(),{
					levels: cookie.categories.toString()
				})
			},

			onChange: ({changedCategories, changedServices}) => {
				$.post('/assets/inc/setGDPR.cfm?_cache=' + new Date().getTime(),{
					levels: changedCategories.toString()
				})
				if(CookieConsent.getUserPreferences().acceptedServices.performance.toString().indexOf('Calendly')>-1){
					activateCalendly()
				}
				else{
					deactivateCalendly()
				}
			},

			onModalReady: ({modalName}) => {
				//console.log('ready:', modalName);
			},

			onModalShow: ({modalName}) => {
				//console.log('visible:', modalName);
			},

			onModalHide: ({modalName}) => {
				//console.log('hidden:', modalName);
			},

			categories: {
				necessary: {
					enabled: true,
					readOnly: true
				},
				analytics: {
					autoClear: {
						cookies: [
							{
								name: /^(_ga|_gid|im_|_hjSession|__utm)/
							}
						]
					}
				},
				media: {
					autoClear: {
						cookies: [
							{
								name: /^(vuid|player)/
							}
						]
					},
					services: {
						youtube: {
							label: 'Youtube Embed',
							// PATCH FIX 2: KEINE DOM-Length-Checks mehr.
							// Vorher: $('[data-service="youtube"]').length > 0 als Inline-Check.
							// Problem: Sobald __im.acceptService() das erste Mal lief, hat der
							// iframemanager den Container modifiziert. Live-DOM-Check schlug
							// dadurch fehl -> alle weiteren Toggles wurden zu No-Ops -> Iframe
							// liess sich zur Laufzeit nicht mehr zwischen Video und Vorschaubild
							// hin- und herschalten.
							//
							// Offizielles Pattern aus der Doku ruft acceptService/rejectService
							// direkt auf, ohne DOM-Check. __im selbst wird nur initialisiert
							// wenn YT/X Container existieren -> Truthiness-Guard auf __im genuegt.
							// Ref: https://cookieconsent.orestbida.com/advanced/iframemanager-setup.html
							onAccept: () => { if(__im) __im.acceptService('youtube'); },
							onReject: () => { if(__im) __im.rejectService('youtube'); }
						},
						twitter: {
							label: 'X embed',
							onAccept: () => { if(__im) __im.acceptService('twitter'); },
							onReject: () => { if(__im) __im.rejectService('twitter'); }
						}
					}
				},
				ads: {
					autoClear: true
				},
				performance: {
					autoClear: true
				}
			},

			language: {
				default: langdouble,

				translations: {
					de: {
						consentModal: {
							title: trans['d'].plain_cc_titel,
							description: trans['d'].trans_cc_intro,
							acceptAllBtn: trans['d'].trans_cc_accept_all,
							showPreferencesBtn: trans['d'].trans_cc_modal_titel ,
							footer: '<a href="'+cplanding+'">Datenschutz</a> <a href="'+ipage+'">Impressum</a>'
						},
						preferencesModal: {
							title: trans['d'].trans_cc_modal_titel,
							acceptAllBtn: trans['d'].trans_cc_accept_all,
							acceptNecessaryBtn: 'Nur benötigte',
							savePreferencesBtn: trans['d'].trans_cc_speuichern,
							closeIconLabel: trans['d'].trans_cc_close,
							sections: [
								{
									title: trans['d'].trans_cc_cookie_usage,
									description: trans['d'].trans_cc_usage_txt
								},
								{
									title: 'Unsere Datenschutzbestimmungen',
									description: 'Findest du <a href="'+cplanding+'">hier</a>'
								},
								{
									title: trans['d'].trans_cc_required_cookies,
									description: trans['d'].trans_cc_req_cookies_txt,
									linkedCategory: 'necessary',
									cookieTable: {
										caption: 'Benötigte Cookies',
										headers: {
											name: 'Name',
											description: 'Beschreibung',
											duration: 'Dauer'
										},
										body: [
											{ name: 'CFID', description: 'Session Cookie', duration: '20 Min.' },
											{ name: 'CFTOKEN', description: 'Session Cookie', duration: '20 Min.' },
											{ name: 'cc_cookie', description: 'Consent Einwilligungsstatus', duration: '6 Monate' },
											{ name: 'im_youtube', description: 'Consent Einwilligungsstatus Youtube', duration: '6 Monate' },
											{ name: 'im_twitter', description: 'Consent Einwilligungsstatus X', duration: '6 Monate' },
											{ name: 'HSREG', description: 'User Länderwahl', duration: '1 Monat' }

										]
									}
								},
								{
									title: trans['d'].trans_cc_analytics,
									description: trans['d'].trans_cc_analytics_desc,
									linkedCategory: 'analytics'
								},
								{
									title: 'Werbung',
									description: 'Werbetracker',
									linkedCategory: 'ads'
								},
								{
									title: trans['d'].trans_cc_media,
									description: trans['d'].trans_cc_media_desc,
									linkedCategory: 'media'
								},
								{
									title: 'Weitere Informationen',
									description: 'Findest du im <a href="'+ipage+'">Impressum</a>'
								}
							]
						}
					},
					en: {
						consentModal: {
							title: trans['e'].plain_cc_titel,
							description: trans['e'].trans_cc_intro,
							acceptAllBtn: trans['e'].trans_cc_accept_all,
							showPreferencesBtn: trans['e'].trans_cc_modal_titel ,
							footer: '<a href="'+cplanding+'">Privacy Policy</a> <a href="'+ipage+'">Imprint</a>'
						},
						preferencesModal: {
							title: trans['e'].trans_cc_modal_titel,
							acceptAllBtn: trans['e'].trans_cc_accept_all,
							savePreferencesBtn: trans['e'].trans_cc_speuichern,
							closeIconLabel: trans['e'].trans_cc_close,
							sections: [
								{
									title: trans['e'].trans_cc_cookie_usage,
									description: trans['e'].trans_cc_usage_txt
								},
								{
									title: 'Our privacy policy',
									description: 'you find <a href="'+cplanding+'">here</a>'
								},
								{
									title: trans['e'].trans_cc_required_cookies,
									description: trans['e'].trans_cc_req_cookies_txt,
									linkedCategory: 'necessary',
									cookieTable: {
										caption: 'Necessary Cookies',
										headers: {
											name: 'Name',
											description: 'Description',
											duration: 'Duration'
										},
										body: [
											{ name: 'CFID', description: 'Session Cookie', duration: '20 min.' },
											{ name: 'CFTOKEN', description: 'Session Cookie', duration: '20 min.' },
											{ name: 'cc_cookie', description: 'Consent status', duration: '6 months' },
											{ name: 'im_youtube', description: 'Consent Status Youtube', duration: '6 months' },
											{ name: 'im_twitter', description: 'Consent Status X', duration: '6 months' },
											{ name: 'HSREG', description: 'User country', duration: '1 Monat' }
										]
									}
								},
								{
									title: trans['e'].trans_cc_analytics,
									description: trans['e'].trans_cc_analytics_desc,
									linkedCategory: 'analytics'
								},
								{
									title: 'Advertising',
									description: 'Tracking',
									linkedCategory: 'ads'
								},
								{
									title: trans['e'].trans_cc_media,
									description: trans['e'].trans_cc_media_desc,
									linkedCategory: 'media'
								},
								{
									title: 'More informationen',
									description: 'you find <a href="'+ipage+'">here</a>'
								}
							]
						}
					}
				}
			}
		});

		// ===== PATCH: Banner sichtbar machen mit Buffer ==========================
		// Lighthouse hat zu diesem Zeitpunkt LCP bereits gemessen.
		// 200ms Buffer + Fade-In statt hartes Pop-In = bessere UX.
		setTimeout(function(){
			document.body.classList.add('cc-ready');
		}, 200);
		// ===== /PATCH: Banner sichtbar machen ende ===============================

		$('body').on('click','#mobile-menu .ccrevoke',function(e){
			e.preventDefault()
			CookieConsent.showPreferences();
		})
	}
	// ===== /PATCH: Init-Funktion ende =============================================


	// ===== PATCH: Skip-Logic für wiederkehrende Besucher =========================
	// Wenn Consent-Cookie bereits gesetzt ist, Banner gar nicht initialisieren.
	// Lighthouse simuliert immer Erst-Besuch (kein Cookie) -> diese Zeile hilft
	// vor allem Stammbesuchern (echte User-Performance) und ist eine zusätzliche
	// LCP-Schutzschicht, falls der Visibility-Trick mal versagt.
	function __hasConsent(){
		return document.cookie.indexOf('cc_cookie') !== -1;
	}
	// ===== /PATCH: Skip-Logic ende ===============================================


	// ===== PATCH: Defer-Trigger ===================================================
	// Init erst nach LCP/load + idle, damit der Banner nicht im kritischen
	// Render-Pfad ist. Spart auf Mobile ~400-800ms LCP.
	function __deferCC(){
		if(__hasConsent()){
			document.body.classList.add('cc-ready');
			// iframemanager NICHT sofort, sondern nach DOM-Settle starten -
			// identisches Timing wie der (funktionierende) Erstbesuch-Pfad.
			if('requestIdleCallback' in window){
				requestIdleCallback(__initIframeManager, { timeout: 4000 });
			} else {
				setTimeout(__initIframeManager, 300);
			}
			return;
		}
	
		if('requestIdleCallback' in window){
			requestIdleCallback(__initCookieConsent, { timeout: 4000 });
		} else {
			setTimeout(__initCookieConsent, 2000);
		}
	}

	if(document.readyState === 'complete'){
		__deferCC();
	} else {
		window.addEventListener('load', __deferCC, { once: true });
	}

	// Fallback: Wenn der User auf einen Cookie-Trigger klickt, BEVOR die
	// idle-Init gefeuert hat -> sofort initialisieren und Preferences öffnen.
	// Capture-Phase, damit wir vor dem nativen data-cc-Handler des Plugins sind.
	document.addEventListener('click', function(e){
		var t = e.target && e.target.closest && e.target.closest('.ccrevoke, [data-cc]');
		if(!t) return;

		// Wenn Banner schon initialisiert: Plugin-Logik übernimmt selber.
		if(__ccInited){
			// Sicherheits-Halber cc-ready setzen, falls noch nicht gesetzt
			document.body.classList.add('cc-ready');
			return;
		}

		// Banner noch nicht init -> jetzt initialisieren und Preferences öffnen
		e.preventDefault();
		__initCookieConsent();
		setTimeout(function(){
			if(window.CookieConsent && CookieConsent.showPreferences){
				CookieConsent.showPreferences();
			}
		}, 50);
	}, true);
	// ===== /PATCH: Defer-Trigger ende =============================================

}